import { useEffect, useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from '@mui/material';

const PERIODS = [0, 1, 2, 3, 4, 5];

const selectStyles = {
  mt: 2,
  mb: 2,
  backgroundColor: '#fff',
  boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
  borderRadius: 2,
  '& .MuiInputLabel-root': {
    color: '#555',
    fontSize: 16,
  },
  '& .MuiSelect-select': {
    padding: '16px 20px',
    fontSize: 16,
    fontWeight: 500,
  },
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: '#b2dfdb',
    borderWidth: 2,
  },
  '&:hover .MuiOutlinedInput-notchedOutline': {
    borderColor: '#26b8b8',
  },
  '& .MuiSelect-icon': {
    color: '#26b8b8',
    fontSize: 28,
  },
};

export default function ModalDialog({ setApp, app, open, onClose, handleSubmit, selectedPeriod, selectedDay, language }) {
  const PERIOD_LABELS = {
    0: language ? 'All' : 'Բոլորը',
    1: '1–2',
    2: '3–4',
    3: '5–6',
    4: '7–8',
    5: '9–10',
  };
  const DAYS = language ? ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'] : ['Երկուշաբթի', 'Երեքշաբթի', 'Չորեքշաբթի', 'Հինգշաբթի', 'Ուրբաթ'];
  const APPS = language ? ['Homework', 'Schedule', 'TimeTable', 'PeerTutoring', 'Profile'] : ['Յուրացում', 'Դասացուցակ', 'Ժամատախտակ', 'PeerTutoring', 'Անձնական Էջ'];
  const [period, setPeriod] = useState(selectedPeriod);
  const [day, setDay] = useState(selectedDay);
    
  useEffect(() => {
    if (open) {
      setPeriod(selectedPeriod || 0);
      setDay(selectedDay || 0);
    }
  }, [open, selectedPeriod, selectedDay]);

  const handleSave = () => {
    handleSubmit(app == 1 ? {day} : {day, period});
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: { borderRadius: 3},
      }}
    >
      <DialogTitle sx={{ fontWeight: 600, fontSize: 18 }}>
        App Portal
      </DialogTitle>

      <DialogContent>
        <FormControl fullWidth sx={selectStyles}>
          <InputLabel>{language ? 'App' : 'Ծրագիր'}</InputLabel>
          <Select
            value={app}
            label={language ? 'App' : 'Ծրագիր'}
            onChange={(e) => setApp(e.target.value)}
          >
            {APPS.map((label, index) => (
              <MenuItem key={label} value={index}>
                {label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        {app == 2 ? (<>
          <FormControl fullWidth sx={selectStyles}>
          <InputLabel>{language ? 'Period' : 'Դասաժամ'}</InputLabel>
          <Select
            value={period}
            label={language ? 'Period' : 'Դասաժամ'}
            onChange={(e) => setPeriod(e.target.value)}
          >
            {PERIODS.map((p) => (
              <MenuItem key={p} value={p}>
                {PERIOD_LABELS[p]}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <FormControl fullWidth sx={selectStyles}>
          <InputLabel>{language ? 'Day' : 'Օր'}</InputLabel>
          <Select
            value={day}
            label={language ? 'Day' : 'Օր'}
            onChange={(e) => setDay(e.target.value)}
          >
            {DAYS.map((label, index) => (
              <MenuItem key={label} value={index}>
                {label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        </>) : app == 1 ? <FormControl fullWidth sx={selectStyles}>
          <InputLabel>{language ? 'Day' : 'Օր'}</InputLabel>
          <Select
            value={day}
            label={language ? 'Day' : 'Օր'}
            onChange={(e) => setDay(e.target.value)}
          >
            {DAYS.map((label, index) => (
              <MenuItem key={label} value={index}>
                {label}
              </MenuItem>
            ))}
          </Select>
        </FormControl> : ""}
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2 }}>
        {app == 0  ? "" : app == 3 ? "" : (<><Button
          onClick={handleSave}
          variant="contained"
          sx={{
            borderRadius: 2,
            px: 3,
            bgcolor: '#26b8b8',
            '&:hover': { bgcolor: '#1ea0a0' },
          }}
        >
          {language ? 'Save' : 'Հաստատել'}
        </Button>
        <Button
          onClick={onClose}
          sx={{ borderRadius: 2, bgcolor: '#ffffff' }}
        >
          {language ? 'Cancel' : 'Փակել'}
        </Button></>)}
      </DialogActions>
    </Dialog>
  );
}
